import type { IntlShape } from 'react-intl';
import type { AppSketch } from '@api/appBuilder';
import { SKETCH_MESSAGES, VIEWER_NAMES } from './sketch.constants';

export type SketchFocus = { kind: 'viewer' } | { kind: 'control'; index: number } | { kind: 'export' } | { kind: 'build' };

export interface SketchStep {
  readonly text: string;
  readonly focus: SketchFocus;
}

const viewersPhrase = (intl: IntlShape, sketch: AppSketch): string => {
  const [first, second] = sketch.viewers.map((viewer) => intl.formatMessage(VIEWER_NAMES[viewer]));
  return second ? intl.formatMessage(SKETCH_MESSAGES.and, { first, second }) : first;
};

/** A step's index is also how many parts of the drawing are on paper by then. */
export const sketchTimeline = (intl: IntlShape, sketch: AppSketch): SketchStep[] => [
  { text: intl.formatMessage(SKETCH_MESSAGES.viewer, { viewers: viewersPhrase(intl, sketch) }), focus: { kind: 'viewer' } },
  ...sketch.controls.map(
    (control, index): SketchStep => ({
      text: intl.formatMessage(SKETCH_MESSAGES.control, { label: control.label.toLocaleLowerCase() }),
      focus: { kind: 'control', index },
    }),
  ),
  { text: intl.formatMessage(SKETCH_MESSAGES.export), focus: { kind: 'export' } },
  { text: intl.formatMessage(SKETCH_MESSAGES.build), focus: { kind: 'build' } },
];
